// ── hooks/index.js ────────────────────────────────────────────────────────────
// Re-exports everything for backward compatibility.
// New code should import directly from specific files:
//   import { toISO, fmtDate } from '../utils/dates';
//   import { buildShareText } from '../utils/orders';
//   import { useAppContext } from '../AppContext';

import { useState, useEffect, useCallback, useRef } from 'react';
import { auth, db, onAuthStateChanged, getDoc, doc } from '../firebase/config';

export function useAuth() {
  const [user, setUser] = useState(null);
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    return onAuthStateChanged(auth, async u => {
      if (u) {
        const snap = await getDoc(doc(db, 'users', u.uid));
        setProfile(snap.exists() ? snap.data() : { name: u.email, role: 'staff' });
        setUser(u);
      } else {
        setUser(null);
        setProfile(null);
      }
      setLoading(false);
    });
  }, []);

  return { user, profile, loading };
}

export function useToast() {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);

  const show = useCallback((msg, ms = 2400) => {
    setToast(msg);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setToast(null), ms);
  }, []);

  return { toast, show };
}

// Date utilities — also available from '../utils/dates'
export function toISO(d) {
  return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
}

export function fmtDate(d) {
  return d.toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function addDays(d, n) {
  const r = new Date(d); r.setDate(r.getDate() + n); return r;
}

export function getWeekStart(d) {
  const r = new Date(d); r.setHours(0,0,0,0); r.setDate(r.getDate() - r.getDay()); return r;
}

// Order utilities — also available from '../utils/orders'
export function buildShareText(o) {
  const del = new Date(o.deliveryDate + 'T00:00:00');
  let m = `*Order — ${o.customerName}*\nDelivery: ${fmtDate(del)}\nType: ${o.type === 'confirmed' ? 'Confirmed' : 'Anticipated'}\n`;
  if (o.products) m += `\nItems:\n${o.products}\n`;
  if (o.amount)   m += `\nAmount: Rs.${Number(o.amount).toLocaleString('en-IN')}`;
  if (o.notes)    m += `\nNote: ${o.notes}`;
  return m;
}
